module.exports = __webpack_public_path__ + "static/media/image-code.4da28779.png";